import { LockKey, Truck, BookBookmark, Receipt } from "@phosphor-icons/react";

const items = [
  { icon: LockKey, title: "Secure payment", text: "UPI, cards & netbanking via Cashfree. Card details never touch our servers." },
  { icon: BookBookmark, title: "Two editions", text: "Paperback for reading, cloth-bound hardcover to keep on the shelf." },
  { icon: Truck, title: "Packed by hand", text: "Copies dispatched within 2–3 working days. Tracking ID shared by email." },
  { icon: Receipt, title: "GST invoice", text: "Auto-generated tax invoice attached to every order." },
];

export function TrustBadges({ compact = false }) {
  return (
    <div className={`grid gap-4 ${compact ? "grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-4"}`} data-testid="trust-badges">
      {items.map(({ icon: Icon, title, text }) => (
        <div key={title} className="flex gap-3 rounded-sm border border-foreground/10 bg-white/70 p-5">
          <Icon weight="duotone" size={26} className="mt-0.5 shrink-0 text-accent" />
          <div>
            <p className="text-sm font-semibold">{title}</p>
            {!compact && <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{text}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
